import React from 'react';

import { Box, ButtonGroup } from '@mui/material';

import { FORM_FIELD_TYPES, FormField } from '../../../components/form/form-field';
import SaveButton from '../../../components/form/save-button';

const ReadExcelForm = ({ form, onSubmit, onChange }) => {
  const { errors } = form.formState;
  const formControl = form.control;

  return (
    <Box
      component="form"
      onSubmit={form.handleSubmit(onSubmit)}
      onReset={form.reset}
      onChange={onChange}
    >
      <FormField
        controlId="readExcelFormName"
        label="name"
        name="name"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter name"
        required
        error={errors.name?.message}
      />
      <FormField
        controlId="readExcelFormType"
        label="type"
        name="type"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        disabled
        error={errors.type?.message}
      />
      <FormField
        controlId="readExcelFormWorksheets"
        label="worksheets"
        name="properties.worksheets"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter worksheet names"
        error={errors.properties?.worksheets?.message}
      />
      <FormField
        controlId="readExcelFormUseHeader"
        label="useHeader"
        name="properties.useHeader"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
      />
      <FormField
        controlId="readExcelFormTreatEmptyValuesAsNulls"
        label="treatEmptyValuesAsNulls"
        name="properties.treatEmptyValuesAsNulls"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
      />
      <FormField
        controlId="readExcelFormInferSchema"
        label="inferSchema"
        name="properties.inferSchema"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
      />
      <FormField
        controlId="readExcelFormAddColorColumns"
        label="addColorColumns"
        name="properties.addColorColumns"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
      />
      <FormField
        controlId="readExcelFormStartColumn"
        label="startColumn"
        name="properties.startColumn"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter start column"
        error={errors.properties?.startColumn?.message}
      />
      <FormField
        controlId="readExcelFormEndColumn"
        label="endColumn"
        name="properties.endColumn"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter end column"
        error={errors.properties?.endColumn?.message}
      />
      <FormField
        controlId="readExcelFormTimestampFormat"
        label="timestampFormat"
        name="properties.timestampFormat"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter timestamp format"
        error={errors.properties?.timestampFormat?.message}
      />
      <FormField
        controlId="readExcelFormExcerptSize"
        label="excerptSize"
        name="properties.excerptSize"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter excerpt size"
        error={errors.properties?.excerptSize?.message}
      />
      <ButtonGroup>
        <SaveButton />
      </ButtonGroup>
    </Box>
  );
};

export default ReadExcelForm;
